
import * as types from './const'


export const getMissTicketAction = (data) => async dispatch => {
    if (data) {
        dispatch({
            type: types.GET_MISS_TICKET,
            data
        })
    }else{
        dispatch({
            type: types.GET_MISS_TICKET_ERR,
            
        })
    }
}

